module.exports = __webpack_public_path__ + "static/media/gneckstatic.1236e47b.png";